import React, { forwardRef, ComponentProps } from "react";
import { CpBadgeVariants } from "./cp-badge-variants/cp-badge-variant";
import { CpBadgeIntent, CpBadgeProps } from "./cp-badge";
import { tw, always } from "src/utils";
import { CpBadgeContent } from "./cp-badge-variants/cp-badge-content";

type CpBadgeButtonProps = CpBadgeProps & ComponentProps<"button">;

export const CpBadgeButton = forwardRef<HTMLButtonElement, CpBadgeButtonProps>(
  (props, ref) => {
    const {
      children,
      className,
      disabled,
      iconLeft,
      iconOnly,
      iconRight,
      intent = "base",
      size = "md",
      ...rest
    } = props;
    return (
      <button
        ref={ref}
        className={always(
          tw(
            CpBadgeVariants({
              button: true,
              disabled: disabled,
              iconOnly: !!iconOnly,
              intent: intent as CpBadgeIntent,
              size,
            }),
          ),
          className,
        )}
        disabled={disabled}
        {...rest}
      >
        <CpBadgeContent
          iconLeft={iconLeft}
          iconOnly={iconOnly}
          iconRight={iconRight}
          size={size}
        >
          {children}
        </CpBadgeContent>
      </button>
    );
  },
);
